define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var user = require('user');
    var GoldenChipsModel = require('replacers/total-goldenchips-balance/total-goldenchips-balance.model');

    module.exports = GoldenChipsModel.extend({
        defaults: function() {
            return {
                amount: 0,
                currencyCode: user.get('currencyCode'),
                count: 0
            };
        },
        parse: function(response) {
            var goldenChipsBalances = response.data.goldenChipsBalances || [];

            return goldenChipsBalances.length
                ? _
                    .chain(goldenChipsBalances)
                    .map(this.multiplyCountWithAmount)
                    .reduce(this.sumMultiplications, {})
                    .value()
                : this.toJSON();
        },

        multiplyCountWithAmount: function(balance) {
            return _.extend({}, balance.goldenChipValue, {
                amount: balance.goldenChipsCount * balance.goldenChipValue.amount,
                count: balance.goldenChipsCount
            });
        },

        sumMultiplications: function(totalBalance, balance) {
            return _.extend({}, balance, {
                amount: (totalBalance.amount || 0) + balance.amount,
                count: (totalBalance.count || 0) + balance.count
            });
        },
    });
});
